import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import BulletList from 'components/BulletList';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import { MenuTextButton } from 'components/Menu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var dateOptions = {
  month: 'numeric',
  year: 'numeric',
  day: 'numeric'
};
function ListPopup(_ref) {
  var onClose = _ref.onClose,
    titleKey = _ref.titleKey,
    listItems = _ref.listItems,
    _ref$listLayout = _ref.listLayout,
    listLayout = _ref$listLayout === void 0 ? 'list' : _ref$listLayout;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isStack = listLayout === 'stack';
  return /*#__PURE__*/_jsxs(Box, {
    role: "dialog",
    "aria-labelledby": titleKey,
    px: "m",
    py: "s",
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h1",
      size: "extra-small",
      id: titleKey,
      mb: "xs",
      mr: "l",
      children: t(titleKey)
    }), /*#__PURE__*/_jsx(Button, {
      icon: "x",
      variant: "transparent",
      title: t('actions_close_modal'),
      onClick: onClose,
      position: "absolute",
      right: "xxs",
      top: "xxs"
    }), /*#__PURE__*/_jsx(Box, {
      fontSize: "s",
      children: isStack ? /*#__PURE__*/_jsx(Stack, {
        withDividers: true,
        spacing: "xs",
        children: listItems
      }) : /*#__PURE__*/_jsx(BulletList, {
        children: listItems
      })
    })]
  });
}
function DetailsDropdown(_ref2) {
  var listItems = _ref2.listItems,
    _children = _ref2.children,
    isDisabled = _ref2.isDisabled,
    titleKey = _ref2.titleKey,
    listLayout = _ref2.listLayout;
  return /*#__PURE__*/_jsx(Dropdown, {
    placement: "bottom-end",
    renderInPlace: true,
    allowTooltipClicks: true,
    content: function content(dropdown) {
      return /*#__PURE__*/_jsx(ListPopup, {
        listItems: listItems,
        onClose: dropdown.close,
        listLayout: listLayout,
        titleKey: titleKey
      });
    },
    children: function children(dropdown) {
      return /*#__PURE__*/_jsx(MenuTextButton, {
        ref: dropdown.ref,
        onClick: dropdown.toggle,
        "aria-expanded": dropdown.isOpen ? 'true' : 'false',
        isDisabled: isDisabled,
        children: _children
      });
    }
  });
}
export default DetailsDropdown;